
/**
 * 새 대화 생성 요청
 */
export interface ConversationCreateRequest {
  /**
   * 기본 사용 모델
   * @nullable
   */
  model?: string | null;
  /**
   * 대화 제목
   * @nullable
   */
  title?: string | null;
}
